/* Carbon District premium layer: shell (3 Nov 2026).
   Upgrades the header, mega menu, search overlay, mobile menu, basket drawer and empty basket that cdx-v4.js builds.
   It adds to those parts and replaces none of them. It reads the saved car only through CDSBC (CDSBC.car, CDSBC.fit,
   CDSBC.rows). Loaded on every page after cdu-components.js. Runs on DOMContentLoaded, after cdx-v4.js has built the shell. */
(function () {
  'use strict';
  var CDU = (window.CDU = window.CDU || {});
  if (CDU.shell) return;
  CDU.shell = { version: '1.0.0' };

  var doc = document, root = doc.documentElement;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (_) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (_) {} },
  };
  var session = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (_) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (_) {} },
  };

  function start() {
    var CFG = {};
    try { CFG = JSON.parse($('#cdx-cfg').textContent); } catch (_) {}
    var FREE = CFG.free === 1;
    var fmt;
    try { fmt = new Intl.NumberFormat(CFG.loc || 'en-IE', { style: 'currency', currency: CFG.cur || 'EUR' }); } catch (_) { fmt = new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR' }); }
    var money = function (c) { return fmt.format((+c || 0) / 100); };
    var url = function (p) { var r = CFG.root || '/'; return (r.charAt(r.length - 1) === '/' ? r : r + '/') + String(p || '').replace(/^\//, ''); };
    var handleOf = function (u) { return String(u || '').split('?')[0].replace(/\/$/, '').split('/').pop(); };
    var hasCar = function () { return !!(window.CDSBC && CDSBC.car && CDSBC.rows); };

    /* The saved car: stored as a collection URL by cdx-v4.js, named only by CDSBC.car. */
    function garage() {
      var s = store.get('cdx-car', null);
      return s && s.u && hasCar() ? CDSBC.car(s.u) : null;
    }
    var partsWord = function (n) { return n + ' part' + (n === 1 ? '' : 's'); };

    /* ---------------------------------------------------------------- layers: focus, inert, scroll lock */
    var FOC = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
    function focusables(r) { return $$(FOC, r).filter(function (n) { return !!(n.offsetWidth || n.offsetHeight || n.getClientRects().length); }); }
    var drawer = $('#drawer'), mnav = $('#mnav');
    function openLayer() {
      var ov = $('.ov.open'); if (ov) return $('.panel', ov) || ov;
      if (drawer && drawer.classList.contains('open')) return drawer;
      if (mnav && mnav.classList.contains('open')) return mnav;
      return null;
    }
    function syncLock() {
      var on = !!(openLayer());
      if (on && !root.classList.contains('cdu-lock')) {
        var sb = window.innerWidth - root.clientWidth;
        if (sb > 0) root.style.setProperty('--cdu-sbw', sb + 'px');
      }
      root.classList.toggle('cdu-lock', on);
      if (!on) root.style.removeProperty('--cdu-sbw');
    }
    function layer(el, label) {
      if (!el) return;
      var was = null, prev = null;
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
      var sync = function () {
        var now = el.classList.contains('open');
        el.inert = !now;
        if (now === was) return;
        var first = was === null; was = now;
        if (first) return;
        if (now) {
          prev = doc.activeElement && doc.activeElement !== doc.body ? doc.activeElement : null;
          try { el.focus({ preventScroll: true }); } catch (_) {}
        } else if (prev && doc.contains(prev)) {
          /* later: cdx-v4's Escape handler also moves focus (to the last overlay's opener), so this runs after it */
          var back = prev; prev = null;
          setTimeout(function () { try { back.focus({ preventScroll: true }); } catch (_) {} }, 30);
        }
        syncLock();
      };
      new MutationObserver(sync).observe(el, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
      sync();
    }
    layer(drawer); layer(mnav);
    /* Overlays (search, car chooser, quick view) are visibility:hidden when closed, so only the lock and the trap apply. */
    $$('.ov').forEach(function (o) {
      new MutationObserver(syncLock).observe(o, { attributes: true, attributeFilter: ['class'] });
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var o = openLayer(); if (!o) return;
      var f = focusables(o), a = doc.activeElement;
      if (!f.length) { e.preventDefault(); try { o.focus(); } catch (_) {} return; }
      var first = f[0], last = f[f.length - 1];
      if (!o.contains(a)) { e.preventDefault(); first.focus(); return; }
      if (e.shiftKey && (a === first || a === o)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    });

    /* ---------------------------------------------------------------- section data (JSON through the Section Rendering API) */
    function section(name, path) {
      var u = url(path || '');
      return fetch(u + (u.indexOf('?') < 0 ? '?' : '&') + 'sections=' + name)
        .then(function (r) { return r.json(); })
        .then(function (j) { var h = j[name] || ''; return JSON.parse(h.slice(h.indexOf('{'), h.lastIndexOf('}') + 1)); });
    }
    var lookCache = {};
    /* Parts for one car. A collection handle names the car. An empty handle means the car the basket's parts belong to. */
    function look(handle) {
      var k = handle || '*';
      if (!lookCache[k]) {
        lookCache[k] = section('cdu-cart-look', handle ? 'collections/' + handle : '').catch(function () { delete lookCache[k]; return null; });
      }
      return lookCache[k];
    }
    function tileHTML(p, fitOk) {
      var t = esc(p.t);
      return '<div class="cdu-mt"><a class="cdu-mt__i" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(p.img) + '" alt="" width="64" height="64" loading="lazy" decoding="async"></a>' +
        '<div class="cdu-mt__b"><a class="cdu-mt__t" href="' + esc(p.u) + '">' + t + '</a><span class="cdu-mt__p">' + money(p.pr) + '</span></div>' +
        (p.s && fitOk ? '<button type="button" class="cdu-mt__add" data-add="' + esc(p.v) + '" aria-label="Add ' + t + ' to basket">Add</button>' : '<a class="cdu-mt__add" href="' + esc(p.u) + '" aria-label="View ' + t + '">View</a>') + '</div>';
    }
    var skelTiles = function (n) { var h = ''; for (var i = 0; i < n; i++) h += '<div class="cdu-mt cdu-mt--skel" aria-hidden="true"><span class="cdu-skel cdu-skel--img"></span><span class="cdu-skel cdu-skel--text"></span><span class="cdu-skel cdu-skel--btn"></span></div>'; return h; };
    var shortTitle = function (t) { return String(t || '').split('(')[0].trim(); };

    /* ---------------------------------------------------------------- search: recent searches, cars with the most parts, parts */
    (function search() {
      var ov = $('#ov-search'), q = $('#q'), panel = ov && $('.panel', ov), bd = $('#q-res');
      if (!ov || !q || !panel || !bd) return;
      var RK = 'cdu-recent';
      var recents = function () { return (store.get(RK, []) || []).filter(Boolean).slice(0, 5); };
      function remember(t) {
        t = String(t || '').trim(); if (t.length < 2) return;
        var l = recents().filter(function (x) { return x.toLowerCase() !== t.toLowerCase(); }); l.unshift(t);
        store.set(RK, l.slice(0, 5));
      }
      var sx = doc.createElement('div'); sx.className = 'cdu-sx'; sx.id = 'cdu-sx';
      panel.insertBefore(sx, bd.nextSibling);
      var PARTS = ['Front lip', 'Rear diffuser', 'Spoiler', 'Mirror caps'];
      function popular() {
        if (!hasCar()) return [];
        return CDSBC.rows().slice().sort(function (a, b) { return (b.n || 0) - (a.n || 0); }).slice(0, 4)
          .map(function (r) { var c = CDSBC.car(r.u); return c ? { u: r.u, label: c.label, n: r.n } : null; }).filter(Boolean);
      }
      function paint() {
        var typed = !!q.value.trim();
        ov.classList.toggle('cdu-typing', typed);
        ov.classList.toggle('cdu-idle', !typed);
        sx.hidden = typed;
        if (typed) return;
        var rc = recents(), pop = popular(), h = '';
        if (rc.length) h += '<div class="cdu-sx__g"><div class="cdu-sx__h"><span>Recent searches</span><button type="button" class="cdu-sx__clr" data-cdu-clear-recent>Clear</button></div><div class="cdu-sx__c">' +
          rc.map(function (t) { return '<button type="button" class="cdu-chip" data-q="' + esc(t) + '">' + esc(t) + '</button>'; }).join('') + '</div></div>';
        if (pop.length) h += '<div class="cdu-sx__g"><div class="cdu-sx__h"><span>Cars with the most parts listed</span></div><div class="cdu-sx__c">' +
          pop.map(function (c) { return '<a class="cdu-chip" href="' + esc(c.u) + '">' + esc(c.label) + '<small>' + c.n + '</small></a>'; }).join('') + '</div></div>';
        h += '<div class="cdu-sx__g"><div class="cdu-sx__h"><span>Search by part</span></div><div class="cdu-sx__c">' +
          PARTS.map(function (t) { return '<button type="button" class="cdu-chip" data-q="' + esc(t) + '">' + esc(t) + '</button>'; }).join('') + '</div></div>';
        sx.innerHTML = h;
      }
      sx.addEventListener('click', function (e) {
        var c = e.target.closest('[data-q]');
        if (c) { q.value = c.dataset.q; q.dispatchEvent(new Event('input', { bubbles: true })); q.focus(); return; }
        if (e.target.closest('[data-cdu-clear-recent]')) { store.set(RK, []); paint(); }
      });
      q.addEventListener('input', paint);
      q.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') remember(q.value);
        if (e.key === 'ArrowDown' && !$('.res', bd)) { var f = $('button,a', sx); if (f) { e.preventDefault(); f.focus(); } }
      });
      bd.addEventListener('click', function (e) { if (e.target.closest('.res')) remember(q.value); }, true);
      new MutationObserver(function () { if (ov.classList.contains('open')) paint(); }).observe(ov, { attributes: true, attributeFilter: ['class'] });
      paint();
    })();

    /* ---------------------------------------------------------------- mega menu: opens on the make with the most parts */
    (function mega() {
      var m = $('#mega-car'); if (!m || !hasCar()) return;
      /* No saved car: open on the make with the most parts listed, not the first make in the alphabet */
      if (!garage()) {
        var tot = {}; CDSBC.rows().forEach(function (r) { tot[r.mk] = (tot[r.mk] || 0) + (r.n || 0); });
        var top = Object.keys(tot).sort(function (a, b) { return tot[b] - tot[a]; }).filter(function (mk) { return $('[data-m="' + mk.replace(/"/g, '') + '"]', m); })[0];
        var tb = top && $('[data-m="' + top + '"]', m); if (tb) tb.click();
      }
    })();

    /* ---------------------------------------------------------------- mobile menu: the saved car, then the help links */
    (function menu() {
      var box = $('#mnav-car'); if (!box || !mnav) return;
      function paint() {
        var g = garage();
        box.innerHTML = g
          ? '<a class="mnav__mine" href="' + esc(g.u) + '"><span class="label">Your car</span><b>' + esc(g.label) + '</b><small>' + (g.n ? partsWord(g.n) + ' listed' : 'See what fits') + '</small></a><button type="button" class="mnav__chg" data-open-garage>Change car</button>'
          : '<button type="button" class="mnav__add" data-open-garage><span class="label">Your car</span><b>Add your car</b><small>We show only the parts listed for it.</small></button>';
      }
      paint();
      window.addEventListener('cdx-car', paint);
      window.addEventListener('storage', function (e) { if (e.key === 'cdx-car') paint(); });
      /* the car chooser opens above the menu: close the menu first so it is not behind it when the chooser closes */
      doc.addEventListener('click', function (e) {
        if (e.target.closest('#mnav [data-open-garage]')) { mnav.classList.remove('open'); mnav.setAttribute('aria-hidden', 'true'); }
      });
    })();

    /* ---------------------------------------------------------------- basket drawer: totals, complete the look, empty basket */
    var lines = $('#lines');
    function emptyHTML(g, inPage) {
      var h = '<div class="cdu-empty cdu-own' + (inPage ? ' cdu-empty--page' : '') + '"><span class="cdu-empty__k">Your basket is empty</span>';
      if (g) {
        h += '<p class="cdu-empty__t">Parts for your ' + esc(g.label) + '</p><p>' + (g.n ? partsWord(g.n) + ' listed for it. ' : '') + 'We confirm the exact fit before anything is made.</p>' +
          '<a class="btn" href="' + esc(g.u) + '">See parts for your ' + esc(g.short) + '</a>' +
          '<div class="cdu-tiles" data-cdu-tiles aria-live="polite">' + skelTiles(3) + '</div>' +
          '<button type="button" class="linklike" data-open-garage>Change car</button>';
      } else {
        h += '<p class="cdu-empty__t">Start with your car</p><p>Choose your car and we show only the parts listed for it.</p>' +
          '<button type="button" class="btn" data-open-garage>Add your car</button><span class="cdu-empty__l"><a class="cdu-link" href="' + esc(url('pages/shop-by-collection')) + '">Shop by car</a><a class="cdu-link" href="' + esc(url('collections/all')) + '">All parts</a></span>';
      }
      return h + '</div>';
    }
    function fillEmpty(host, g) {
      if (!g) return;
      var h = handleOf(g.u);
      look(h).then(function (d) {
        var tiles = $('[data-cdu-tiles]', host); if (!tiles) return;
        var list = d && d.p ? d.p.slice(0, 3) : [];
        tiles.innerHTML = list.map(function (p) { return tileHTML(p, CDSBC.fit(g.u, g.u, p.t) === 'yes'); }).join('');
        if (!list.length) tiles.remove();
      });
    }
    var isOpen = function () { return drawer && drawer.classList.contains('open'); };
    function onLines() {
      if (!lines) return;
      var empty = !$('.line', lines);
      drawer.classList.toggle('is-empty', empty);
      if (empty && !$('.cdu-empty', lines)) {
        $$(':scope > p', lines).forEach(function (p) { p.remove(); });
        lines.insertAdjacentHTML('beforeend', emptyHTML(garage(), false));
      }
      var em = $('.cdu-empty', lines);
      if (em && isOpen() && !em.dataset.filled) { em.dataset.filled = '1'; fillEmpty(em, garage()); }
      if (!empty) { var e = $('.cdu-empty', lines); if (e) e.remove(); }
      schedule();
    }
    var planT, planN = 0;
    /* No request is made while the drawer is closed. Opening it brings the totals and suggestions up to date. */
    function schedule() { clearTimeout(planT); if (isOpen()) planT = setTimeout(plan, 140); }
    function cartGet() { return fetch(url('cart.js'), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
    function paintTotals(cart) {
      var set = function (id, v) { var n = $('#' + id); if (n) n.textContent = v; };
      set('cdu-parts', money(cart.items_subtotal_price));
      var off = (cart.items_subtotal_price || 0) - (cart.total_price || 0), row = $('#cdu-off-row');
      var tot = $('.cdu-tot'); if (tot) tot.toggleAttribute('data-off', off > 0);
      if (row) {
        row.hidden = off <= 0;
        if (off > 0) { set('cdu-off-l', ((cart.cart_level_discount_applications || [])[0] || {}).title || 'Discount'); set('cdu-off', '−' + money(off)); }
      }
      var n = $('#drawer-n'); if (n) { n.hidden = !cart.item_count; n.textContent = cart.item_count || ''; }
    }
    function plan() {
      var n = ++planN;
      cartGet().then(function (cart) {
        if (n !== planN) return;
        paintTotals(cart);
        if (!cart.item_count) return;
        var g = garage(), fitYes = $$('.line-fit.is-yes', lines).length > 0;
        var handle = g && fitYes ? handleOf(g.u) : '';
        var ids = cart.items.map(function (i) { return i.product_id; });
        var key = handle + '|' + ids.join(',');
        if (lines.dataset.cduKey === key && $('.cdu-more', lines)) return;
        look(handle).then(function (d) {
          if (n !== planN || !d) return;
          var list = (d.p || []).filter(function (p) { return ids.indexOf(p.i) < 0; }).slice(0, 3);
          lines.dataset.cduKey = key;
          var old = $('.cdu-more', lines); if (old) old.remove();
          if (!list.length) return;
          var dc = hasCar() ? CDSBC.car(d.u) : null;   /* the car's name comes from CDSBC.car: no chassis code */
          var title = handle && g ? 'More for your ' + g.label : 'More for the ' + (dc ? dc.label : shortTitle(d.t));
          lines.insertAdjacentHTML('beforeend', '<section class="cdu-more cdu-own" aria-label="Complete the look"><h3 class="cdu-more__k"><span class="cdu-marker" aria-hidden="true"></span>Complete the look</h3><p class="cdu-more__t">' + esc(title) + '</p>' +
            list.map(function (p) { return tileHTML(p, g && handle ? CDSBC.fit(g.u, g.u, p.t) === 'yes' : true); }).join('') + '</section>');
        });
      }).catch(function () {});
    }
    if (lines && drawer) {
      new MutationObserver(function (muts) {
        var own = function (nd) { return nd && nd.nodeType === 1 && nd.closest && nd.closest('.cdu-own'); };
        var real = muts.some(function (m) {
          if (m.type === 'attributes') return !own(m.target);
          if (own(m.target)) return false;
          return Array.prototype.some.call(m.addedNodes, function (x) { return !own(x); }) || Array.prototype.some.call(m.removedNodes, function (x) { return !(x.nodeType === 1 && x.classList.contains('cdu-own')); });
        });
        if (real) onLines();
      }).observe(lines, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      onLines();
      new MutationObserver(function () { if (isOpen()) onLines(); }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      window.addEventListener('cdx-car', function () {
        var e = $('.cdu-empty', lines); if (e) e.remove();
        lines.dataset.cduKey = '';
        onLines();
      });
    }

    /* ---------------------------------------------------------------- basket page: empty basket leads to the saved car */
    (function cartPage() {
      /* the basket page's "More for the ..." heading is built in Liquid from the collection title: name the car with CDSBC.car instead */
      var page = $('#ccart');
      function carName() {
        $$('.ccart__more').forEach(function (m) {
          var a = $('.link-arrow', m), h = $('.sec__head h2', m); if (!a || !h || !hasCar()) return;
          var c = CDSBC.car(a.getAttribute('href')); if (!c) return;
          var t = 'More for the ' + c.label; if (h.textContent !== t) h.textContent = t;
        });
      }
      if (page) { carName(); new MutationObserver(carName).observe(page, { childList: true, subtree: true }); }
      var host = $('.ccart__empty'); if (!host) return;
      var paint = function () { var g = garage(); host.innerHTML = emptyHTML(g, true); fillEmpty(host, g); };
      paint();
      window.addEventListener('cdx-car', paint);
    })();

    CDU.shell.ready = true;
    doc.dispatchEvent(new CustomEvent('cdu:shell-ready'));
  }

  /* cdx-v4.js builds the shell in a later deferred script, so wait for DOMContentLoaded unless the page is fully loaded */
  if (doc.readyState === 'complete') start(); else doc.addEventListener('DOMContentLoaded', start);
})();
